<template>
  <v-container
    id="about"
    tag="section"
  >
    <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">XTERRA WOOD domy z drewna</h1></base-subheading>
    <v-col cols="10" offset-md="1">

      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        <strong>Xterra Wood</strong> należy do grupy firm działających na głównie polskim rynku nieruchomości. Grupa składa się z agencji nieruchomości, firmy finansowej, ogólnobudowlanej i deweloperskiej. Pozornie młodą firmę tworzą ludzie z kilkuletnim doświadczeniem w branży. Najnowszy członek holdingu, Xtermo, to spółka odpowiedzialna za wdrażanie innowacyjnych cienkowarstwowych materiałów termoizolacyjnych, które obok tradycyjnej, murowanej technologii budowlanej są z powodzeniem stosowane w domach z bali. Promujemy zdrowy styl życia, tworząc wysokiej jakości przestrzenie inspirowane i otoczone naturalnymi, pięknymi i zdrowymi materiałami.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Zapewniając najwyższy standard jakości domów Xterra Wood używamy najlepszych możliwych materiałów. Elementy drewniane są dokładnie sprawdzane, certyfikowane, a wszystkie procesy są zarządzane w sposób zrównoważony. Oferujemy wszystkie rodzaje drewna w zależności od wymagań klienta, świerk syberyjski, modrzew lub sosnę. Grubość bali dopasowana jest do wymagań naszych klientów w taki sam sposób jak okna, drzwi i wszystkie inne powierzchnie.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Wszystkie domy i budynki z bali <strong>Xterra Wood</strong> są produkowane w jednej z najnowocześniejszych na świecie fabryk domów z bali w Polsce. Zakład produkcyjny wykorzystuje unikalne technologie i wysoki poziom automatyzacji, który pomaga zapewnić dokładność wymiarową stolarki do 2 mm. Firma pracuje na najnowszym oprogramowaniu SEMA i Dietrich oraz korzysta z najbardziej zaawansowanych maszyn do obróbki drewna HUNDEGGER (firmy bawarskiej). Oznacza to, że możemy realizować wszystkie projekty, zarówno letnie, jak i całoroczne budując domy, które przetrwają pokolenia i pamiętając, że drewno jest naszym głównym materiałem budowlanym od tysięcy lat. Dzięki naszym architektom, konstruktorom i wiedzy na temat domów z drewna, proces powstawanie i budowy jest szybki i łatwy.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Zawsze gwarantujemy bardzo wysoki poziom konkurencyjności przy niezmiennie wysokiej jakości. Jesteśmy otwarci na wszystkie rodzaje i możliwości współpracy. Najnowsza technologia produkcji, którą mamy do dyspozycji pozwala bardzo szybko produkować wszelakie elementy drewniane oraz domy z bali i konstrukcje szkieletowe.
      </p>
      <p class="text-right font-weight-light" style="font-family:Montserrat"><i>Passion for design, perfection and quality</i></p>

    </v-col>

    <hr>

    <v-row>

      <v-col cols="3">
        <v-card>
          <v-img
            :src="require(`@/assets/articles/factory-1.jpg`)"
            width="100%"
          >
          </v-img>
        </v-card>
      </v-col>
      
      <v-col cols="3">
        <v-card>
          <v-img
            :src="require(`@/assets/articles/factory-2.jpg`)"
            width="100%"
          >
          </v-img>
        </v-card>
      </v-col>

      <v-col cols="3">
        <v-card>
          <v-img
            :src="require(`@/assets/articles/factory-3.jpg`)"
            width="100%"
          >
          </v-img>
        </v-card>
      </v-col>

      <v-col cols="3">
        <v-card>
          <v-img
            :src="require(`@/assets/articles/factory-4.jpg`)"
            width="100%"
          >
          </v-img>
        </v-card>
      </v-col>

    </v-row>
    

  </v-container>
</template>

<script>
  export default {
    name: 'HomeAbout',
  }
</script>
